import { formValues } from 'utils/formValues';
import { injectIntl } from 'react-intl';
import Employment from './Employment';
import config from './config';
import * as validation from './validation';

export const CONFIG = config;
export const VALIDATION = validation;

export default injectIntl(
  formValues(
    'occupationType',
    'startOccupationDate',
    'employmentType',
    'employmentCode',
    'employerName',
    'emplUID',
    'proInvolvement',
    'firmEmployeeQuestionInd',
    'professionalQuestionInd',
    'activeOccupations',
    'hasAdminInvolvement',
    'hasTenPercentInvolvement',
    'hasTwentyPercentInvolvement',
    'adminInvolvementList',
    'tenPercentInvolvementList',
    'twentyPercentInvolvementList',
    'employerAddress',
    'employerPhoneNumber',
  )(Employment),
);
